export const CART_DRAWER_OPEN = 'tps:cart-drawer-open';
export const CART_DRAWER_UPDATED = 'tps:cart-drawer-updated';

export const openCartDrawer = () => {
    if (typeof window === 'undefined') {
        return;
    }

    window.dispatchEvent(new CustomEvent(CART_DRAWER_OPEN));
};

export const notifyCartUpdated = (cartData = null) => {
    if (typeof window === 'undefined') {
        return;
    }

    window.dispatchEvent(new CustomEvent(CART_DRAWER_UPDATED, { detail: cartData }));
};
